<template>
    <div
        ref="console-log"
        class="app-ai-relay-history">
        <div v-for="(item, index) in history" class="app-ai-relay-history__grouping">
            <div 
                class="element-comment--sent element-comment"
                :data-item="item.id"
                v-if="!item.message_type">
                    <div class="element-comment__details">
                        <p class="element-comment__name">You</p>
                        <p class="element-comment__date-time">{{ localizeDate(item.created_at).format('MMM D, YYYY h:mm A') }}</p>
                    </div>
                    <div class="element-comment__text">
                        <pre>{{ item.user_query }}</pre>
                    </div>
                    <div class="element-comment__reactions">
                        <button
                            v-if="index > 0"
                            @click="toggleActions(item.id)"
                            type="button"
                            class="element-comment__reaction">
                            <svg class="element-icon--delete element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-delete"></use></svg>
                        </button>
                    </div>
            </div>
            <div v-if="index > 0 && currentId && currentId === item.id" class="app-toast--ai-delete app-toast is--inline is--warning">
                <div class="app-toast__text">
                    <p class="app-toast__title">You’ll be deleting this message and all subsequent responses below, are you sure?</p>
                </div>
                <button
                    @click="toggleActions(item.id, true)"
                    title="Dismiss"
                    class="app-toast__close element-button--icon element-button">
                    <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
                </button>
                <div class="app-toast__buttons">
                    <button
                        @click="removeItem(item.id)"
                        title="Remove below history"
                        class="element-button--text element-button">
                        Delete
                    </button>
                </div>
            </div>
            <div
                :class="['element-comment--received element-comment', { 'request-log__loading': item.loading }]"
                v-if="!item.message_type">
                    <div class="element-featured-icon is--ai is--sm">
                        <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
                    </div>
                    <div class="element-comment__details">
                        <p class="element-comment__name">AI chat</p>
                        <p class="element-comment__date-time">{{ localizeDate(item.created_at).format('MMM D, YYYY h:mm A') }}</p>
                    </div>
                    <div class="element-comment__text">
                        <pre>{{ item.ai_response }}</pre>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { localizeDate } from '../helpers/util'

export default {
    components: {

    },
    props: {
        source: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            history: this.source ?? [],
            currentId: null,
            isProcessing: false
        }
    },
    computed: {

    },
    watch: {
        source (value) {
            this.history = value
        },
        async history (value) {
            await this.$nextTick()
            if (this.$refs['console-log'])
                this.$refs['console-log'].scrollTop = this.$refs['console-log'].scrollHeight
        },
    },
    methods: {
        localizeDate,
        toggleActions (id, close) {
            if (this.isProcessing)
                return false

            if (this.currentId && this.currentId === id || close === true)
            {
                this.currentId = null
                return false
            }

            this.currentId = id
        },
        async removeItem (id) {

            if (this.isProcessing)
                return false

            this.isProcessing = true
            this.currentId = null
            let ids = [id]
            let found = false
            _.forEach(this.history, function(item) {
                if (found === true)
                {
                    ids.push(item.id)
                    return
                }
                if (item.id === id)
                    found = true
            })

            // generate an array of Message IDs starting from the passed ID onwards and pass them in the payload
            await this.$emit('removeItemFromHistory', ids)

            this.isProcessing = false
        }
    },
}
</script>
